/* esm.sh - rxjs@7.8.1/dist/esm/internal/util/createObject */
function o(c,r){return c.reduce((e,t,n)=>(e[t]=r[n],e),{})}export{o as createObject};
//# sourceMappingURL=createObject.mjs.map